module.exports = __webpack_public_path__ + "img/UTKODA-2.4bff2d0a.jpg";